<template>
  <div class="info-slot-container py-1">
    <div class="p-1">
      <EvaluationForm
        location="slot"
        :show-back-button="showBackButton"
        :isPrefill="isPrefill"
        :prefillData="isFromNotification ? null : data"
        :evaluationId="evaluationId"
        :evaluation="evaluation"
        :formValidationData="formValidationData"
        :currentSpecialForms="currentSpecialForm"
        :isCreateSpecialForms="currentSpecialForm ? true : false"
        :idFormAnswerOwner="idFormAnswerOwner"
        :dataToReplace="dataToReplace"
        @go-back-to-list="goBackToList()"
        @navigate-to-form="handleNavigateToForm($event)"
      />
    </div>
  </div>
</template>

<script>
import EvaluationForm from "@/components/operationalSecurity/EvaluationForm.vue";
import layoutMixin from "@/mixins/layoutMixin";
import { SOURCES } from "@/config/layoutConfig";
import axios from "@/libs/axios";

export default {
  name: "OperationalSecurityFormSlot",
  mixins: [layoutMixin],
  components: {
    EvaluationForm,
  },
  props: {
    data: {
      type: Object,
    },
    slotId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      SOURCES,
      filters: null,
      isPrefill: false,
      evaluationId: null,
      evaluation: null,
      formValidationData: {},
      source: "slot",
      currentSpecialForm: "",
      idFormAnswerOwner: 0,
      dataToReplace: null,
    };
  },
  watch: {
    data: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  beforeMount() {
    this.initData();
  },
  beforeDestroy() {
    if (this.slotId) {
      this.$store.dispatch("operational_security/clearHistory", this.slotId);
    }
  },
  computed: {
    isFromNotification() {
      return this.data?.source === SOURCES.MAIN_SEARCH;
    },
    showBackButton() {
      const hasHistory = this.$store.getters["operational_security/hasNavigationHistory"](this.slotId);
      return hasHistory;
    },
  },
  methods: {
    initData() {
      if (this.slotId) {
        this.$store.dispatch("operational_security/clearHistory", this.slotId);
      }
      this.filters = this.data.filters;
      this.dataToReplace = this.data?.dataToReplace;
      if (this.data.source === SOURCES.MAIN_SEARCH) {
        this.formValidationData = this.data.formValidationData;
        this.evaluation = this.data.formValidationData.form;
        this.evaluationId = this.formValidationData.form.id;
        return;
      }
      if (this.data.is_prefill) {
        this.isPrefill = true;
        this.currentSpecialForm = this.data?.currentSpecialForms;
        this.idFormAnswerOwner = this.data.id;
      } else {
        this.evaluationId = this.data.id;
      }
      this.evaluation = this.data;
    },
    async fetchFormEvaluation() {
      return axios.get(
        `/v1/operational-security-forms/template-answers/${this.evaluationId}?withData=true`
      );
    },
    async goBackToList() {
      const hasHistory = this.$store.getters["operational_security/hasNavigationHistory"](
        this.slotId
      );

      if (hasHistory) {
        const previousForm = await this.$store.dispatch(
          "operational_security/navigateBack",
          this.slotId
        );

        if (previousForm) {
          try {
            const response = await axios.get(
              `/v1/operational-security-forms/template-answers/${previousForm.id}`
            );
            const formData = response.data;

            this.evaluationId = formData.id;
            this.evaluation = formData;

            await this.$nextTick();
          } catch (error) {
            console.error("Error navigating to previous form:", error);
          }
        }
      }
    },

    async handleNavigateToForm(formId) {
      try {
        if (this.evaluationId) {
          await this.$store.dispatch("operational_security/navigateToForm", {
            slotId: this.slotId,
            formData: {
              id: this.evaluationId,
              data: this.evaluation
            }
          });
        }

        const response = await axios.get(
          `/v1/operational-security-forms/template-answers/${formId}?withData=true`
        );
        const formData = response.data;

        this.evaluationId = formData.id;
        this.evaluation = formData;

        await this.$nextTick();
      } catch (error) {
        console.error("Error navigating to form:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-slot-container {
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
